import type { UserDocument } from 'api/rest/user_documents';
import type {
    InitialDocConfig,
    InitialDocFlagState,
    InitialDocsState,
} from 'types/initialDocuments';

export const INITIAL_DOCS: InitialDocConfig[] = [
    { key: 'passport', nameEn: 'Passport', labelKey: 'passport' },
    { key: 'resume', nameEn: 'Resume', labelKey: 'resume' },
    { key: 'proofOfAddress', nameEn: 'Proof of address', labelKey: 'proofOfAddress' },
];

export const emptyDocsState = (): InitialDocsState => ({
    passport: null,
    resume: null,
    proofOfAddress: null,
});

export const emptyFlagState = (): InitialDocFlagState => ({
    passport: false,
    resume: false,
    proofOfAddress: false,
});

/** A document is provided when the backend returned a non-null resource_name. */
export const hasResource = (doc: UserDocument | null | undefined): boolean =>
    Boolean(doc && typeof doc.resource_name === 'string' && doc.resource_name.length > 0);
